import React, { useState } from 'react';
import {
    Clock,
    DollarSign,
    Award,
    Calendar,
    Users,
    FileText,
    Bell,
    BarChart,
    Book
} from 'lucide-react';

// 導入各模組演示組件
import AttendanceDemo from '../components/demos/AttendanceDemo';
import SalaryDemo from '../components/demos/SalaryDemo';
import PerformanceDemo from '../components/demos/PerformanceDemo';
import SchedulingDemo from '../components/demos/SchedulingDemo';
import CalendarDemo from '../components/demos/CalendarDemo';
import TrainingDemo from '../components/demos/TrainingDemo';
import ReportDemo from '../components/demos/ReportDemo';
import NotificationDemo from '../components/demos/NotificationDemo';

const DemoPage = () => {
    // 定義模組列表
    const modules = [
        {
            id: 'attendance',
            name: '基礎出勤管理',
            icon: <Clock />,
            component: AttendanceDemo
        },
        {
            id: 'salary',
            name: '薪資與假勤管理',
            icon: <DollarSign />,
            component: SalaryDemo
        },
        {
            id: 'performance',
            name: '績效與考核管理',
            icon: <Award />,
            component: PerformanceDemo
        },
        {
            id: 'scheduling',
            name: '排班與工時管理',
            icon: <Calendar />,
            component: SchedulingDemo
        },
        {
            id: 'calendar',
            name: '會議與行事曆管理',
            icon: <Users />,
            component: CalendarDemo
        },
        {
            id: 'training',
            name: '培訓與進修管理',
            icon: <Book />,
            component: TrainingDemo
        },
        {
            id: 'report',
            name: '報表與數據分析',
            icon: <BarChart />,
            component: ReportDemo
        },
        {
            id: 'notification',
            name: '通知與提醒',
            icon: <Bell />,
            component: NotificationDemo
        }
    ];

    // 當前選中的模組
    const [currentModule, setCurrentModule] = useState(modules[0]);

    // 渲染當前模組的組件
    const CurrentModuleComponent = currentModule.component;

    console.log('Modules:', modules);
    console.log('Current Module:', currentModule);

    // 如果模組為空，提供默認顯示
    if (!modules || modules.length === 0) {
        return <div>無法載入演示模組</div>;
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* 頁面標題 */}
            <header className="bg-primary-600 text-white py-16">
                <div className="container mx-auto text-center">
                    <h1 className="text-4xl font-bold mb-4">智能出勤與人事管理系統 - 功能演示</h1>
                    <p className="text-xl opacity-90">
                        透過互動式介面，全方位了解系統的強大功能與智能管理體驗
                    </p>
                </div>
            </header>

            {/* 模組選擇區域 */}
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                    {modules.map((module) => (
                        <button
                            key={module.id}
                            onClick={() => setCurrentModule(module)}
                            className={`flex items-center justify-center p-4 rounded-lg transition-all duration-300 ${currentModule.id === module.id
                                ? 'bg-primary-600 text-white shadow-lg'
                                : 'bg-white text-gray-700 hover:bg-primary-50 shadow-md'
                                }`}
                        >
                            {React.cloneElement(module.icon, {
                                size: 24,
                                className: currentModule.id === module.id
                                    ? 'text-white'
                                    : 'text-primary-600'
                            })}
                            <span className="ml-2 text-sm md:text-base">{module.name}</span>
                        </button>
                    ))}
                </div>

                {/* 當前模組演示區域 */}
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <CurrentModuleComponent />
                </div>
            </div>
        </div>
    );
};

export default DemoPage;